class ScrollHelper {
  constructor() {
    this.bindEvents();
  }

  /**
   * Bind the required events.
   */
  bindEvents(): void {
    // Add on scroll event
    window.addEventListener(
      'scroll',
      () => {
        if (
          window.scrollY <= 20 &&
          document.body.getAttribute('data-scrolled') === 'true'
        ) {
          document.body.removeAttribute('data-scrolled');
        } else if (window.scrollY > 20) {
          document.body.setAttribute('data-scrolled', 'true');
        }
      },
      false
    );
  }
}

export const scrollHelperInit = (): void => {
  new ScrollHelper();
};
